module.exports = __webpack_public_path__ + "img/playgrounds-in-motion.df29bee.jpg";